import { render, staticRenderFns } from "./addDebtTaskModal.vue?vue&type=template&id=0ea48a37&"
import script from "./addDebtTaskModal.vue?vue&type=script&lang=js&"
export * from "./addDebtTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports